"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService = _interopRequireDefault(require("./AbstractService"));

var _TypeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/TypeException"));

var _FactoryException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/FactoryException"));

var _IrwAuthService = _interopRequireDefault(require("./service/auth/IrwAuthService"));

var _NifAuthService = _interopRequireDefault(require("./service/auth/NifAuthService"));

var _IrwPlatformService = _interopRequireDefault(require("./service/platform/irw/IrwPlatformService"));

var _NwpPlatformService = _interopRequireDefault(require("./service/platform/nwp/NwpPlatformService"));

var _RoigPlatformService = _interopRequireDefault(require("./service/platform/roig/RoigPlatformService"));

var _IrwRetailItemService = _interopRequireDefault(require("./service/article/retailitem/IrwRetailItemService"));

var _NwpRetailItemService = _interopRequireDefault(require("./service/article/retailitem/NwpRetailItemService"));

var _WprwRetailItemService = _interopRequireDefault(require("./service/article/retailitem/WprwRetailItemService"));

var _DexfWebPlannerService = _interopRequireDefault(require("./service/article/dexf/DexfWebPlannerService"));

var _ShoppingBagService = _interopRequireDefault(require("./service/shoppingbag/ShoppingBagService"));

var _NifCartService = _interopRequireDefault(require("./service/shoppingbag/NifCartService"));

var _IrwStoreAvailabilityService = _interopRequireDefault(require("./service/storeavailability/irw/IrwStoreAvailabilityService"));

var _IrwStoreService = _interopRequireDefault(require("./service/store/IrwStoreService"));

var _NwpStoreService = _interopRequireDefault(require("./service/store/NwpStoreService"));

var _NwpStoreItemService = _interopRequireDefault(require("./service/storeavailability/nwp/NwpStoreItemService"));

var _ApplicationUrlService = _interopRequireDefault(require("./service/url/ApplicationUrlService"));

var _IowsVpcService = _interopRequireDefault(require("./service/vpc/iows/IowsVpcService"));

var _DexfVpcService = _interopRequireDefault(require("./service/vpc/dexf/DexfVpcService"));

var _LocalizationService = _interopRequireDefault(require("./service/localization/LocalizationService"));

var _SeriesGalleryService = _interopRequireDefault(require("./service/seriesgallery/SeriesGalleryService"));

var _OneWebAuthService = _interopRequireDefault(require("./service/auth/OneWebAuthService"));

var _OneWebCartService = _interopRequireDefault(require("./service/shoppingbag/OneWebCartService"));

var _OneWebShoppingListService = _interopRequireDefault(require("./service/shoppingbag/OneWebShoppingListService"));

var _MvEcomService = _interopRequireDefault(require("./service/shoppingbag/MvEcomService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used for handling instances of registered services.
 */
var ServiceFactory = /*#__PURE__*/function () {
  function ServiceFactory() {
    _classCallCheck(this, ServiceFactory);
  }

  _createClass(ServiceFactory, null, [{
    key: "register",

    /**
     * Registers a service class.
     *
     * @param {Class} serviceClass Service class to register.
     */
    value: function register(serviceClass) {
      if (!(serviceClass.prototype instanceof _AbstractService.default)) {
        throw new _TypeException.default('Failed to register. Type of service class "' + serviceClass.name + '" is not an instance of AbstractService');
      }

      this.classes.set(serviceClass.factoryName, serviceClass);
    }
    /**
     * Returns a single instance of a service.
     *
     * @param {string} factoryName Factory name of the service.
     * @returns {AbstractService} Instance of AbstractService.
     */

  }, {
    key: "getService",
    value: function getService(factoryName) {
      var service = this.classes.get(factoryName);

      if (!service) {
        throw new _FactoryException.default('Failed return service instance. Service with factory name "' + factoryName + '" is not registered.');
      }

      return service.getInstance();
    }
    /**
     * Checks if a service is registered.
     *
     * @param {string} factoryName Factory name of the service.
     * @returns {boolean} TRUE if the service is registered.
     */

  }, {
    key: "hasService",
    value: function hasService(factoryName) {
      return this.classes.get(factoryName) !== undefined;
    }
    /**
     * Returns the registered classes.
     *
     * @returns {Map} Map with registered AbstractService classes.
     */

  }, {
    key: "classes",
    get: function get() {
      this._classes = this._classes || new Map();
      return this._classes;
    }
  }]);

  return ServiceFactory;
}();

exports.default = ServiceFactory;
ServiceFactory.register(_IrwAuthService.default);
ServiceFactory.register(_NifAuthService.default);
ServiceFactory.register(_OneWebAuthService.default);
ServiceFactory.register(_IrwPlatformService.default);
ServiceFactory.register(_NwpPlatformService.default);
ServiceFactory.register(_RoigPlatformService.default);
ServiceFactory.register(_IrwRetailItemService.default);
ServiceFactory.register(_NwpRetailItemService.default);
ServiceFactory.register(_WprwRetailItemService.default);
ServiceFactory.register(_DexfWebPlannerService.default);
ServiceFactory.register(_ShoppingBagService.default);
ServiceFactory.register(_NifCartService.default);
ServiceFactory.register(_OneWebCartService.default);
ServiceFactory.register(_OneWebShoppingListService.default);
ServiceFactory.register(_IrwStoreAvailabilityService.default);
ServiceFactory.register(_IrwStoreService.default);
ServiceFactory.register(_NwpStoreService.default);
ServiceFactory.register(_NwpStoreItemService.default);
ServiceFactory.register(_ApplicationUrlService.default);
ServiceFactory.register(_IowsVpcService.default);
ServiceFactory.register(_DexfVpcService.default);
ServiceFactory.register(_LocalizationService.default);
ServiceFactory.register(_SeriesGalleryService.default);
ServiceFactory.register(_MvEcomService.default);